import Vue from "vue"
import Router from "vue-router"
import store from '@/store/index'
// @ts-ignore
import Main from "@/views/main/main.vue"
import GoodsLibraryRoute from '@/views/goods_library/router'
import ConfigurationRoute from '@/views/configuration/router'
import OrderFormRoute from '@/views/order_form/router'
import MemberRoute from '@/views/member/router'
import StaffRoute from '@/views/staff/router'
import DataCenterRoute from '@/views/data_center/router'
import AiAssistantRoute from '@/views/ai_assistant/router'
import MarketRoute from '@/views/market/router'
// @ts-ignore
import Privilege from '@/views/privilege/privilege.vue'
// @ts-ignore
import DownloadNavigation from '@/views/download_navigation/download_navigation.vue'
import DataScreen from '@/views/data_screen/data_screen.vue'
import DataScreen2 from '@/views/data_screen/data_screen2.vue'

console.log(store)
Vue.use(Router)

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'router-active',
    routes: [{
        path: '*',
        redirect: '/main',
        meta: {
            title: '零售后台管理'
        }
    }, {
        path: '/privilege',
        component: Privilege
    }, {
        path: '/dataScreen',
        component: DataScreen
    }, {
        path: '/dataScreen2',
        component: DataScreen2
    }, {
        path: '/downloadNavigation',
        component: DownloadNavigation,
        meta: {
            title: '下载中心'
        }
    }, {
        path: '/main',
        component: Main,
        children: [{
            path: '',
            redirect: AiAssistantRoute.path
        },
        {
            ...AiAssistantRoute,
            meta: {
                privilegeId: 0
            },
        },
        {
            ...DataCenterRoute,
            meta: {
                privilegeId: 3
            },
        },
        {
            ...GoodsLibraryRoute,
            meta: {
                privilegeId: 0
            },
        },
        {
            ...OrderFormRoute,
            meta: {
                privilegeId: 0
            },
        },
        {
            ...MemberRoute,
            meta: {
                privilegeId: 4
            },
        },
        {
            ...StaffRoute,
            meta: {
                privilegeId: 0
            },
        },
        {
            ...MarketRoute,
            meta: {
                privilegeId: 0
            }
        },
        {
            ...ConfigurationRoute,
            meta: {
                privilegeId: 5
            },
        }
        ]
    }]
} as any)

router.beforeEach((to, from, next) => {
    if (isCanGoInThisModule(to, from, next)) {
        next()
    } else {
        next({
            path: '/privilege',
            query: {
                redirect: to.fullPath
            },
            replace: true
        })
    }
})

function isCanGoInThisModule(to, from, next) {
    document.title = to.meta.title || '零售后台管理'
    console.log(to)
    const green = [
        '/privilege',
        '/downloadNavigation',
        '/dataScreen',
        '/dataScreen2'
    ]
    if (green.includes(to.path)) {
        return true
    }
    if (store.getters['shop/canIGoIn']()) {
        return to.matched.every(match => store.getters['shop/canIUse'](match.meta.privilegeId))
    } else {
        return false
    }
    // return to.matched.every(record => {
    //     if (true) {
    //         return store.getters['shop/canIGoIn']()
    //     } else {
    //         return true
    //     }
    // })
}

export default router
